'use strict';

import BaseService from './base.service';

class OperativeSpendingsService extends BaseService {
    /* @ngInject */
    constructor(
        OperativeSpending,
        SegaUser
    ) {
        super(OperativeSpending, SegaUser);
        this.defaultOrder = 'createdAt ASC';
    }

    void(opts = {id: 0, reason: ''}) {
        return this.Model.void({
            id: opts.id,
            reason: opts.reason
        }).$promise;
    }

    associate(opts = {id: 0, quoteId: 0, associations: []}) {
        return this.Model.associate({
            id: opts.id,
            quoteId: opts.quoteId,
            associations: opts.associations
        }).$promise;
    }

    disassociate(opts = {id: 0}) {
        return this.Model.disassociate({
            id: opts.id
        }).$promise;
    }

    findAssociable(filter) {
        return this.Model.findAssociable({
            filter: filter
        }).$promise;
    }
}

export default OperativeSpendingsService;
